import { removeNetworkedObject } from "../utils/removeNetworkedObject";

const DIST = 1000;

AFRAME.registerComponent("aux-extreme-distance", {
  schema: {
    distance: { default: 1 }
  },
  init() {
    const sceneEl = document.querySelector("a-scene");

    const pos = this.el.object3D.position;

    if (pos.x < -DIST || pos.x > DIST || pos.y < -DIST || pos.y > DIST || pos.z < -DIST || pos.z > DIST) {
      removeNetworkedObject(sceneEl, this.el, true);
    }
  },
  tick(now) {
    // Throttle to 5fps
    if (now - this.lastTick < 600) return;
    this.lastTick = now;

    const scene = this.el.sceneEl;
    if (!scene.is("entered")) return;
  }
});
